// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Status_toggle__1uiPi","active":"Status_active__3caJq"};